import React from 'react';
import Banner from '../Banner/Banner';

const Home = () => {
    return (
        <div style={{ overflow: "hidden" }}>
            <Banner />
        </div>
    )
}

export default Home;